export default __webpack_public_path__ + "static/media/youtube-media.637bb6f6.svg";